// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1o-9h","validationTips":"StatementDescriptor_validationTips__h0IKf"};